export enum ReferenceBehavior {
  STRONG = 'strong',
  WEAK = 'weak',
  DISABLED = 'disabled',
}
